/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
} from 'antd';
import { getEstadosGlobales } from 'api/catalogos';
import { getGrupos } from 'api/estructuraOrganizacional/grupos';
import { getRolesDeUsuario } from 'api/estructuraOrganizacional/rolesDeUsuario';
import {
  deleteFuncion,
  getFuncion,
  getFunciones,
  patchFuncion,
  postFuncion,
} from 'api/usuarios/funciones';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { filterRoles } from 'utils/normalizers';

export const usuarioFuncionPermission = {
  permissionModel: 'funcion',
  catalogsModels: [],
  tabsModels: [],
};

const FuncionesDeUsuario = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [disableEditar, setDisableEditar] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleInactivo, setVisibleInactivo] = useState(false);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getFunciones();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _estadosGlobales,
        _grupos,
        _roles,
      ] = await Promise.all([
        getFunciones(),
        getEstadosGlobales(),
        getGrupos(),
        getRolesDeUsuario(),
      ]);
      const filteredRoles = filterRoles(_grupos, _roles);
      if (mounted) {
        setData(formatReceived(_data));
        setEstadosGlobales(_estadosGlobales);
        setGrupos(filteredRoles);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setDisableEditar(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _funcion = await getFuncion(match.id);
    setTimeout(() => {
      if (_funcion) {
        form.resetFields();
        _funcion?.estados_globales !== ESTATUS_ACTIVO ? setDisableEditar(true) : setDisableEditar(false);
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_funcion));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchFuncion(key, values) : postFuncion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys) {
        const [key] = selectedRowKeys;
        const deleted = await deleteFuncion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una Función ya autorizada');
      }
      const vals = {
        ...form.getFieldsValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchFuncion(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Descripcion',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 200,
    },
    {
      titleText: 'Rol',
      dataIndex: 'grupo',
      key: 'grupo',
      width: 200,
      render: (val) => grupos.find((e) => e.id === val)?.name,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          disableDelete={
            data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
          }
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'funcion', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
            },
          ]}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Función de Usuario`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableEditar}
            />
          )}
          onCancel={onCancel}
          forceRender
          width="40%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="descripcion"
                  label="Descripción"
                  rules={rules.required}
                >
                  <Input
                    disabled={disableEditar}
                  />
                </Form.Item>
                <Form.Item
                  name="grupo"
                  label="Rol"
                  rules={rules.required}
                >
                  <Select
                    keyProp="id"
                    labelProp="name"
                    dataSource={grupos}
                    disabled={disableEditar}
                  />
                </Form.Item>
                <Form.Item
                  name="justificacion"
                  label="Justificación"
                  rules={rules.required}
                >
                  <Input
                    disabled={disableEditar}
                  />
                </Form.Item>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  initialValue={ESTATUS_ACTIVO}
                  rules={rules.required}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estadosGlobales}
                    disabled={selectedRowKeys.length <= 0 || disableEditar}
                    activeInactive={!disableEditar}
                    onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`la Función ${form.getFieldValue('descripcion')}`}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setVisibleAutorizar(false);
          }}
          open={visibleAutorizar}
          contentTitle={`Autorizar la función ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleInactivo(false);
          }}
          contentTitle={`Inactivar la función ${form.getFieldValue('descripcion')}`}
          open={visibleInactivo}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default FuncionesDeUsuario;
